import React from 'react'
import {
  ListFilter,
  // Pagination
} from '../../../components'
import {
  ListNav,
  Sidebar,
  List,
  Featured
} from './index'
import events from '../../../database/events.json'

const MainContent = ({embed, byId, eventIds}) => {
  const [filtered, setFiltered] = React.useState(false)
  const [data, setData] = React.useState(events)

  React.useEffect(() => {
    if(filtered){
      setData(events.slice(0, 3))
    }else{
      setData(events)
    }
  }, [filtered])

  React.useEffect(() => {
    if(byId && eventIds){
      const result = events.filter(d => eventIds.includes(d.id))
      setData(result)
    }
  }, [byId, eventIds])

  return (
    <section className="container mx-auto hidden lg:block">
      <div className={`flex flex-wrap -mx-4 ${embed ? 'lg:pb-12' : 'py-16' }`}>
        {
          !embed &&
          <aside className="w-3/12 px-4">
            <Sidebar filtered={filtered} setFiltered={setFiltered}/>
          </aside>
        }
        <main className={`${embed ? 'w-full' : 'w-9/12'} px-4`}>
          {
            !embed &&
            <React.Fragment>
              <Featured embed={embed}/>
              <ListNav />
              <ListFilter filtered={filtered} setFiltered={setFiltered}/>
            </React.Fragment>
          }
          <List data={data} embed={embed}/>
          {/* <Pagination /> */}
        </main>
      </div>
    </section>
  )
}

export { MainContent }